import { CLIENT_EMAIL_RE as EMAIL_RE } from "@shared/commission";
import type { ContentRating, IntakeDraft, StepId } from "../types";

export type ChecklistId = "type" | "background" | "usage" | "rating" | "something" | "contact" | "terms" | "actions";
export interface ChecklistItem { id: ChecklistId; done: boolean; required: boolean; step: StepId }

const has = (b: { text: string; refs: string[] }) => b.text.trim().length > 0 || b.refs.length > 0;

export function computeChecklist(d: IntakeDraft, opts: { ratingOptions: ContentRating[] }): ChecklistItem[] {
  const chars = d.characters.slice(0, d.characterCount);
  return [
    { id: "type", done: chars.every((c) => !!c.type), required: true, step: "type" },
    { id: "background", done: !!d.backgroundType, required: true, step: "scene" },
    { id: "usage", done: !!d.usageType, required: true, step: "scene" },
    { id: "rating", done: opts.ratingOptions.length <= 1 || !!d.contentRating, required: true, step: "scene" },
    // Guide, never limit: any picture or any words about a character is enough.
    { id: "something", done: chars.every((c) => has(c.look) || has(c.action) || has(c.extra)), required: true, step: "characters" },
    { id: "contact", done: d.clientName.trim().length > 0 && EMAIL_RE.test(d.clientEmail.trim()) && !!d.postingPermission, required: true, step: "contact" },
    { id: "terms", done: d.tosAccepted, required: true, step: "review" },
    { id: "actions", done: chars.every((c) => has(c.action)), required: false, step: "characters" },
  ];
}

export function requiredDone(items: ChecklistItem[]): boolean {
  return items.every((i) => !i.required || i.done);
}
